'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var produce = require('immer');
var axios = require('axios');
var endpoints = require('@piconetworks/endpoints');
var effects = require('redux-saga/effects');
var networkMiddleware = require('@piconetworks/network-middleware');
var Duck = require('extensible-duck');
var reselect = require('reselect');
var get = require('lodash/get');
var isEmpty = require('lodash/isEmpty');
var moment = require('moment');
var currency = require('@piconetworks/currency');
var functions = require('@piconetworks/functions');
var template = require('lodash/template');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var produce__default = /*#__PURE__*/_interopDefaultLegacy(produce);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var Duck__default = /*#__PURE__*/_interopDefaultLegacy(Duck);
var get__default = /*#__PURE__*/_interopDefaultLegacy(get);
var isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(isEmpty);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var currency__default = /*#__PURE__*/_interopDefaultLegacy(currency);
var template__default = /*#__PURE__*/_interopDefaultLegacy(template);

var types = ['GET_LOADER', 'GET_LOADER_SUCCESS', 'GET_LOADER_ERROR', 'REMOVE_LOADER', 'REMOVE_LOADER_SUCCESS', 'REMOVE_LOADER_ERROR', 'UPDATE_LOADER', 'UPDATE_LOADER_PRICING_MONETIZATION_TIERS', 'UPDATE_LOADER_GROUP_BILLING_STATUS', 'UPDATE_LOADER_USER', 'UPDATE_LOADER_USER_NEWSLETTERS', 'LOADER_IS_FETCHING', 'LOADER_IS_NOT_FETCHING', 'FETCH_LOADER_POPUP_SUCCESS'];

var creators = function creators(duck) {
  return {
    getLoader: function getLoader(payload) {
      return Object.assign({
        type: duck.types.GET_LOADER
      }, payload);
    },
    getLoaderSuccess: function getLoaderSuccess(payload) {
      return {
        type: duck.types.GET_LOADER_SUCCESS,
        payload: payload
      };
    },
    removeLoader: function removeLoader(payload) {
      return Object.assign({
        type: duck.types.REMOVE_LOADER
      }, payload);
    },
    updateLoader: function updateLoader(payload) {
      return Object.assign({
        type: duck.types.UPDATE_LOADER
      }, payload);
    },
    updateLoaderPricingMonetizationTiers: function updateLoaderPricingMonetizationTiers(payload) {
      return Object.assign({
        type: duck.types.UPDATE_LOADER_PRICING_MONETIZATION_TIERS
      }, payload);
    },
    updateLoaderGroupBillingStatus: function updateLoaderGroupBillingStatus(payload) {
      return Object.assign({
        type: duck.types.UPDATE_LOADER_GROUP_BILLING_STATUS
      }, payload);
    },
    updateLoaderUser: function updateLoaderUser(payload) {
      return Object.assign({
        type: duck.types.UPDATE_LOADER_USER
      }, payload);
    },
    updateLoaderUserNewsletters: function updateLoaderUserNewsletters(payload) {
      return Object.assign({
        type: duck.types.UPDATE_LOADER_USER_NEWSLETTERS
      }, payload);
    },
    loaderIsFetching: function loaderIsFetching(payload) {
      return Object.assign({
        type: duck.types.LOADER_IS_FETCHING
      }, payload);
    },
    loaderIsNotFetching: function loaderIsNotFetching(payload) {
      return Object.assign({
        type: duck.types.LOADER_IS_NOT_FETCHING
      }, payload);
    },
    fetchLoaderPopupSuccess: function fetchLoaderPopupSuccess(payload) {
      return Object.assign({
        type: duck.types.FETCH_LOADER_POPUP_SUCCESS
      }, payload);
    }
  };
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var initialState = {
  isFetching: false,
  guest: undefined,
  user: undefined
};

var loaderCleaner = function loaderCleaner(_ref) {
  var scope = _ref.scope,
      key = _ref.key,
      payload = _ref.payload;

  if (!payload) {
    return payload;
  } // fix the loader's sometimes null group
  // fix the loader's sometimes null paymentMethods


  if (scope === 'user') {
    if (payload.paymentMethods) {
      var nextState = produce__default['default'](payload, function (draftState) {
        var filteredPaymentMethods = payload.paymentMethods.filter(function (paymentMethod) {
          return paymentMethod !== null;
        });
        draftState.paymentMethods = filteredPaymentMethods;
      });
      return nextState;
    }

    if (key === 'paymentMethods') {
      var _nextState = produce__default['default'](payload, function (draftState) {
        return draftState.filter(function (paymentMethod) {
          return paymentMethod !== null;
        });
      });

      return _nextState;
    }
  }

  return payload;
};

var reducer = function reducer(state, _ref2, duck) {
  var type = _ref2.type,
      payload = _ref2.payload,
      error = _ref2.error;
  return produce__default['default'](state, function (draftState) {
    var _draftState$payload$s;

    switch (type) {
      case duck.types.LOADER_IS_FETCHING:
        draftState.isFetching = true;
        break;

      case duck.types.LOADER_IS_NOT_FETCHING:
        draftState.isFetching = false;
        break;

      case duck.types.GET_LOADER:
        draftState.isFetching = true;
        break;

      case duck.types.GET_LOADER_SUCCESS:
        var payloadToClean = payload.data;
        var currentPopups = (draftState === null || draftState === void 0 ? void 0 : (_draftState$payload$s = draftState[payload.scope]) === null || _draftState$payload$s === void 0 ? void 0 : _draftState$payload$s.popups) || [];
        var newPopups = payloadToClean === null || payloadToClean === void 0 ? void 0 : payloadToClean.popups;
        var popupsToClean;

        if (newPopups) {
          // make sure that new loader requests dont overwrite popups in cache
          popupsToClean = newPopups.reduce(function (acc, popup) {
            var maybeNewPopup = currentPopups.find(function (_ref3) {
              var id = _ref3.id;
              return id === popup.id;
            });

            if (!maybeNewPopup) {
              acc.push(popup);
            }

            return acc;
          }, []);
        }

        draftState[payload.scope] = loaderCleaner({
          type: duck.types.GET_LOADER_SUCCESS,
          scope: payload.scope,
          payload: payloadToClean ? Object.assign({}, payloadToClean, popupsToClean && {
            popups: popupsToClean
          }) : undefined
        });
        draftState.isFetching = false;
        draftState.isError = false;
        break;

      case duck.types.GET_LOADER_ERROR:
        draftState.isFetching = false;
        draftState.isError = true;
        draftState.error = error;
        break;

      case duck.types.REMOVE_LOADER_SUCCESS:
        draftState[payload.scope] = undefined;
        break;

      case duck.types.UPDATE_LOADER:
        if (draftState[payload.scope]) {
          draftState[payload.scope] = Object.keys(payload.loader).reduce(function (loader, key) {
            return Object.assign({}, loader, _defineProperty({}, key, loaderCleaner({
              type: duck.types.UPDATE_LOADER,
              scope: payload.scope,
              key: key,
              payload: payload.loader[key]
            })));
          }, draftState[payload.scope]);
        }

        break;

      case duck.types.UPDATE_LOADER_PRICING_MONETIZATION_TIERS:
        if (payload.tiers) {
          if (draftState.guest) {
            draftState.guest.pricing.monetization.cover_photo = payload.cover_photo;
            draftState.guest.pricing.monetization.is_pledge = payload.is_pledge;
            draftState.guest.pricing.monetization.plan_id = payload.plan_id;
            draftState.guest.pricing.monetization.type = payload.type;
            draftState.guest.pricing.monetization.tiers = payload.tiers;
          }

          if (draftState.user) {
            draftState.user.pricing.monetization.cover_photo = payload.cover_photo;
            draftState.user.pricing.monetization.is_pledge = payload.is_pledge;
            draftState.user.pricing.monetization.plan_id = payload.plan_id;
            draftState.user.pricing.monetization.type = payload.type;
            draftState.user.pricing.monetization.tiers = payload.tiers;
          }
        }

        break;

      case duck.types.UPDATE_LOADER_GROUP_BILLING_STATUS:
        if (payload.groupId && payload.billingStatus) {
          if (draftState.guest && draftState.guest.group.id === payload.groupId) {
            draftState.guest.group.billing_status = payload.billingStatus;
          }

          if (draftState.user && draftState.user.group.id === payload.groupId) {
            draftState.user.group.billing_status = payload.billingStatus;
          }
        }

        break;

      case duck.types.UPDATE_LOADER_USER:
        if (payload.user) {
          draftState.user.user = Object.keys(payload.user).reduce(function (loaderUserUser, key) {
            return Object.assign({}, loaderUserUser, _defineProperty({}, key, loaderCleaner({
              type: duck.types.UPDATE_LOADER_USER,
              scope: 'user',
              key: key,
              payload: payload.user[key]
            })));
          }, draftState.user.user);
        }

        break;

      case duck.types.UPDATE_LOADER_USER_NEWSLETTERS:
        if (payload.newsletters) {
          if (draftState.user) {
            draftState.user.newsletters = payload.newsletters;
          }
        }

        if (draftState.user) {
          draftState.user.user.sync = !!payload.sync;
        }

        break;

      case duck.types.FETCH_LOADER_POPUP_SUCCESS:
        if (payload !== null && payload !== void 0 && payload.popup) {
          var _draftState$scopeToUp;

          var scopeToUpdate = draftState.user ? 'user' : 'guest';

          if ((_draftState$scopeToUp = draftState[scopeToUpdate]) !== null && _draftState$scopeToUp !== void 0 && _draftState$scopeToUp.popups) {
            var idxToUpdate = draftState[scopeToUpdate].popups.findIndex(function (p) {
              var _payload$popup;

              return p.id === ((_payload$popup = payload.popup) === null || _payload$popup === void 0 ? void 0 : _payload$popup.id);
            });

            if (idxToUpdate !== -1) {
              draftState[scopeToUpdate].popups[idxToUpdate] = payload.popup;
            } else {
              draftState[scopeToUpdate].popups.push(payload.popup);
            }
          }
        }

        break;

    }
  });
};

function* getLoader(_ref) {
  var types = _ref.types,
      _ref$scope = _ref.scope,
      scope = _ref$scope === void 0 ? 'guest' : _ref$scope,
      shortCode = _ref.shortCode,
      publisherId = _ref.publisherId,
      _ref$requestPayload = _ref.requestPayload,
      requestPayload = _ref$requestPayload === void 0 ? {} : _ref$requestPayload;

  // 2yy9b4dj, 943w2n8d
  try {
    var _newsletterResponse, _newsletterResponse2;

    var response = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'post',
        baseURL: endpoints.PICO_API_URL(),
        url: scope === 'user' ? endpoints.LOADER() : endpoints.LOADER_GUEST(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        params: Object.assign({}, shortCode && {
          short_code: shortCode
        }),
        data: requestPayload
      }
    });

    if (!response.data) {
      throw Error('No loader data was recieved');
    }

    if (response.data.widget_disabled) {
      throw Error('whitelisted');
    }

    var newsletterResponse = [];

    if (scope === 'user') {
      newsletterResponse = yield effects.putResolve({
        type: networkMiddleware.REQUEST,
        config: {
          method: 'get',
          baseURL: endpoints.PICO_API_URL(),
          url: endpoints.NEWSLETTERS(),
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            publisherid: publisherId
          },
          timeout: 30000
        }
      });
    } // make func - start


    var _response$data = response.data,
        _response$data$pricin = _response$data.pricing,
        pricing = _response$data$pricin === void 0 ? {} : _response$data$pricin,
        group = _response$data.group;

    var _ref2 = pricing || {},
        _ref2$identification = _ref2.identification,
        identification = _ref2$identification === void 0 ? {} : _ref2$identification,
        _ref2$monetization = _ref2.monetization,
        monetization = _ref2$monetization === void 0 ? {} : _ref2$monetization;

    var identificationRuleId = identification.identification_rule_id;
    var planId = monetization.plan_id;

    var _ref3 = group || {},
        groupPlanId = _ref3.plan_id; // make func - end


    var lang = {}; // make func - end
    // make func - call 3x- start

    try {
      if (groupPlanId) {
        var _group = yield effects.call(fetchLang, {
          url: "/".concat(process.env.STAGE, "/").concat(publisherId, "/plans/").concat(groupPlanId, "/EN_US.json")
        });

        lang = Object.assign({}, lang, {
          group: _group
        });
      }
    } catch (error) {
      console.error(error);
    }

    try {
      if (identificationRuleId) {
        var rule = yield effects.call(fetchLang, {
          url: "/".concat(process.env.STAGE, "/").concat(publisherId, "/rules/").concat(identificationRuleId, "/EN_US.json")
        });
        lang = Object.assign({}, lang, {
          rule: rule
        });
      }
    } catch (error) {
      console.error(error);
    }

    try {
      if (planId) {
        var plan = yield effects.call(fetchLang, {
          url: "/".concat(process.env.STAGE, "/").concat(publisherId, "/plans/").concat(planId, "/EN_US.json")
        });
        lang = Object.assign({}, lang, {
          plan: plan
        });
      }
    } catch (error) {
      console.error(error);
    } // make func - end


    yield effects.put({
      type: types.GET_LOADER_SUCCESS,
      payload: {
        scope: scope,
        data: Object.assign({}, response.data, {
          lang: lang,
          default_popup: Object.assign({}, response.data.default_popup, {
            fetched: true
          })
        }, ((_newsletterResponse = newsletterResponse) === null || _newsletterResponse === void 0 ? void 0 : _newsletterResponse.data) && {
          userNewsletters: (_newsletterResponse2 = newsletterResponse) === null || _newsletterResponse2 === void 0 ? void 0 : _newsletterResponse2.data
        })
      }
    });
  } catch (error) {
    console.log(error);
    yield effects.put({
      type: types.GET_LOADER_ERROR,
      error: error.message
    });
  }
}

function* removeLoader(_ref) {
  var types = _ref.types,
      _ref$scope = _ref.scope,
      scope = _ref$scope === void 0 ? 'guest' : _ref$scope;

  try {
    yield effects.put({
      type: types.REMOVE_LOADER_SUCCESS,
      payload: {
        scope: scope
      }
    });
  } catch (error) {
    yield effects.put({
      type: types.REMOVE_LOADER_ERROR,
      error: error.message
    });
  }
}

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var fetchLang = _async(function (_ref) {
  var url = _ref.url;
  return _await(axios__default['default']({
    method: 'get',
    baseURL: endpoints.LANG_URL(),
    timeout: 30000,
    url: url
  }), function (response) {
    if (!response.data) {
      throw Error('no data in response');
    }

    return response.data;
  });
});

var sagas = function sagas(duck) {
  return {
    getLoader: function* getLoader$1(payload) {
      yield getLoader(Object.assign({}, payload, duck));
    },
    removeLoader: function* removeLoader$1(payload) {
      yield removeLoader(Object.assign({}, payload, duck));
    }
  };
};

var takes = function takes(_ref) {
  var types = _ref.types,
      sagas = _ref.sagas;
  return [effects.takeEvery(types.GET_LOADER, sagas.getLoader), effects.takeEvery(types.REMOVE_LOADER, sagas.removeLoader)];
};

var templateCache = {};
var compile = function compile(templateString) {
  var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (templateString === '') {
    console.warn('template failed');
    return null;
  }

  if (!templateCache[templateString]) {
    templateCache[templateString] = template__default['default'](templateString);
  }

  var compiled = templateCache[templateString];
  return compiled(variables);
};
var getTemplateOrDefault = function getTemplateOrDefault(templates, defaults, label) {
  return get__default['default'](templates, label, get__default['default'](defaults, label));
};

/* eslint-disable no-template-curly-in-string */
var donationPlan = {
  customerPromptWithoutName: {
    title: 'Will you renew your support?',
    subtitle: 'Continue funding the content you love.',
    description: null
  },
  customerPromptWithName: {
    title: 'Will you renew your support, ${first_name}?',
    subtitle: 'Continue funding the content you love.',
    description: null
  },
  nonDonorPromptWithoutName: {
    title: 'Thanks for being a loyal member of this community.',
    subtitle: 'Become a donor today to show your support.',
    description: null
  },
  nonDonorPromptWithName: {
    title: 'Thanks for being a loyal member of this community, ${first_name}.',
    subtitle: 'Become a donor today to show your support.',
    description: null
  },
  featureList: {
    show: false,
    title: null,
    list: null
  },
  recurringConfirmationWithoutName: 'Thank you for becoming a sustaining member of our community. Your gift is essential for funding great content on ${publication_name}. When you see our logo in this corner, you can click on it to manage your membership.',
  recurringConfirmationWithName: 'Thank you for becoming a sustaining member of our community, ${first_name}. Your gift is essential for funding great content on ${publication_name}. When you see our logo in this corner, you can click on it to manage your membership.',
  singleConfirmationWithoutName: 'Thank you for being a part of our community of supporters. Your gift is essential for funding great content on ${publication_name}.',
  singleConfirmationWithName: 'Thank you for being a part of our community of supporters, ${first_name}. Your gift is essential for funding great content on ${publication_name}.'
};

/* eslint-disable no-template-curly-in-string */
var subscriptionPlan = {
  promptWithoutName: {
    title: 'Thanks for being a loyal member of this community.',
    subtitle: 'Subscribe now to keep your exclusive access.',
    description: null
  },
  promptWithName: {
    title: 'Thanks for being a loyal member of this community, ${first_name}.',
    subtitle: 'Subscribe now to keep your exclusive access.',
    description: null
  },
  featureList: {
    show: false,
    title: null,
    list: null
  },
  trialConfirmationWithoutName: 'Thank you for trying out a subscription to ${publication_name}. When you see our logo in this corner, you can click on it to manage your subscription.',
  trialConfirmationWithName: 'Thank you for trying out a subscription to ${publication_name}, ${first_name}. When you see our logo in this corner, you can click on it to manage your subscription.',
  confirmationWithoutName: 'Thank you for subscribing to ${publication_name}. When you see our logo in this corner, you can click on it to manage your subscription.',
  confirmationWithName: 'Thank you for subscribing to ${publication_name}, ${first_name}. When you see our logo in this corner, you can click on it to manage your subscription.'
};

var defaultPassPlan = {
  promptWithoutName: {
    title: 'Thanks for being a part of this community.',
    subtitle: 'Buy a pass now to keep your exclusive access.',
    description: null
  },
  promptWithName: {
    title: 'Thanks for being a loyal member of this community, ${first_name}.',
    subtitle: 'Purchase a pass today to get exclusive access to content.',
    description: null
  },
  confirmationWithoutName: 'Your pass has been sucessfully activated! When you see our logo in this corner, you can click on it to manage your membership.',
  confirmationWithName: 'Your pass has been successfully activated, ${first_name}! When you see our logo in this corner, you can click on it to manage your membership.'
};

var DONATION = 'donation';
var SUBSCRIPTION = 'subscription';
var PASS = 'pass';
var retrievePlanPrompt = function retrievePlanPrompt(_ref) {
  var planTemplates = _ref.planTemplates,
      userFirstName = _ref.userFirstName,
      monetizationType = _ref.monetizationType,
      hasPurchased = _ref.hasPurchased;
  var values = {
    title: '',
    subTitle: '',
    description: ''
  };

  if (monetizationType === DONATION) {
    if (hasPurchased) {
      if (userFirstName) {
        values.title = compile(getTemplateOrDefault(planTemplates, donationPlan, 'customerPromptWithName.title'), {
          first_name: userFirstName
        });
        values.subTitle = compile(getTemplateOrDefault(planTemplates, donationPlan, 'customerPromptWithName.subtitle'), {
          first_name: userFirstName
        });
        values.description = compile(getTemplateOrDefault(planTemplates, donationPlan, 'customerPromptWithName.description'), {
          first_name: userFirstName
        });
      } else {
        values.title = getTemplateOrDefault(planTemplates, donationPlan, 'customerPromptWithoutName.title');
        values.subTitle = getTemplateOrDefault(planTemplates, donationPlan, 'customerPromptWithoutName.subtitle');
        values.description = getTemplateOrDefault(planTemplates, donationPlan, 'customerPromptWithoutName.description');
      }
    } else if (userFirstName) {
      values.title = compile(getTemplateOrDefault(planTemplates, donationPlan, 'nonDonorPromptWithName.title'), {
        first_name: userFirstName
      });
      values.subTitle = compile(getTemplateOrDefault(planTemplates, donationPlan, 'nonDonorPromptWithName.subtitle'), {
        first_name: userFirstName
      });
      values.description = compile(getTemplateOrDefault(planTemplates, donationPlan, 'nonDonorPromptWithName.description'), {
        first_name: userFirstName
      });
    } else {
      values.title = getTemplateOrDefault(planTemplates, donationPlan, 'nonDonorPromptWithoutName.title');
      values.subTitle = getTemplateOrDefault(planTemplates, donationPlan, 'nonDonorPromptWithoutName.subtitle');
      values.description = getTemplateOrDefault(planTemplates, donationPlan, 'nonDonorPromptWithoutName.description');
    }
  } else if (monetizationType === SUBSCRIPTION) {
    if (userFirstName) {
      values.title = compile(getTemplateOrDefault(planTemplates, subscriptionPlan, 'promptWithName.title'), {
        first_name: userFirstName
      });
      values.subTitle = compile(getTemplateOrDefault(planTemplates, subscriptionPlan, 'promptWithName.subtitle'), {
        first_name: userFirstName
      });
      values.description = compile(getTemplateOrDefault(planTemplates, subscriptionPlan, 'promptWithName.description'), {
        first_name: userFirstName
      });
    } else {
      values.title = getTemplateOrDefault(planTemplates, subscriptionPlan, 'promptWithoutName.title');
      values.subTitle = getTemplateOrDefault(planTemplates, subscriptionPlan, 'promptWithoutName.subtitle');
      values.description = getTemplateOrDefault(planTemplates, subscriptionPlan, 'promptWithoutName.description');
    }
  } else if (monetizationType === PASS) {
    if (userFirstName) {
      values.title = compile(getTemplateOrDefault(planTemplates, defaultPassPlan, 'promptWithName.title'), {
        first_name: userFirstName
      });
      values.subTitle = compile(getTemplateOrDefault(planTemplates, defaultPassPlan, 'promptWithName.subtitle'), {
        first_name: userFirstName
      });
      values.description = compile(getTemplateOrDefault(planTemplates, defaultPassPlan, 'promptWithName.description'), {
        first_name: userFirstName
      });
    } else {
      values.title = getTemplateOrDefault(planTemplates, defaultPassPlan, 'promptWithoutName.title');
      values.subTitle = getTemplateOrDefault(planTemplates, defaultPassPlan, 'promptWithoutName.subtitle');
      values.description = getTemplateOrDefault(planTemplates, defaultPassPlan, 'promptWithoutName.description');
    }
  }

  return values;
};

/* eslint-disable no-template-curly-in-string */
var requiredRule = {
  menu: {
    title: 'Join the ${publication_name} community.',
    subtitle: 'It’s free, and you’ll get special updates, exclusive content, and more.',
    button: 'Join or Log In'
  },
  prompt: {
    title: 'Log in to continue reading.',
    subtitle: null,
    description: null
  },
  confirmationWithoutName: 'You are now logged in to ${publication_name}.',
  confirmationWithName: 'Hi ${first_name}, you are now logged in to ${publication_name}.'
};

/* eslint-disable no-template-curly-in-string */
var optionalRule = {
  menu: {
    title: 'Join the ${publication_name} community.',
    subtitle: 'It’s free, and you’ll get special updates, exclusive content, and more.',
    button: 'Join or Log In'
  },
  prompt: {
    title: 'Join the ${publication_name} community.',
    subtitle: 'It’s free, and you’ll get special updates, exclusive content, and more.',
    description: null
  },
  confirmationWithoutName: 'You are now logged in to ${publication_name}.',
  confirmationWithName: 'Hi ${first_name}, you are now logged in to ${publication_name}.'
};

var retrieveRulePromptTitle = function retrieveRulePromptTitle(_ref) {
  var ruleTemplates = _ref.ruleTemplates,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required;
  var templateString = '';

  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'prompt.title');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'prompt.title');
  }

  return templateString;
};
var retrieveRulePromptSubtitle = function retrieveRulePromptSubtitle(_ref2) {
  var ruleTemplates = _ref2.ruleTemplates,
      _ref2$required = _ref2.required,
      required = _ref2$required === void 0 ? false : _ref2$required;
  var templateString = '';

  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'prompt.subtitle');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'prompt.subtitle');
  }

  return templateString;
};
var retrieveRulePromptDescription = function retrieveRulePromptDescription(_ref3) {
  var ruleTemplates = _ref3.ruleTemplates,
      _ref3$required = _ref3.required,
      required = _ref3$required === void 0 ? false : _ref3$required;
  var templateString = '';

  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'prompt.description');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'prompt.description');
  }

  return templateString;
};
var retrieveRuleMenuTitle = function retrieveRuleMenuTitle(_ref4) {
  var ruleTemplates = _ref4.ruleTemplates,
      _ref4$required = _ref4.required,
      required = _ref4$required === void 0 ? false : _ref4$required;
  var templateString = '';

  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'menu.title');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'menu.title');
  }

  return templateString;
};
var retrieveRuleMenuSubtitle = function retrieveRuleMenuSubtitle(_ref5) {
  var ruleTemplates = _ref5.ruleTemplates,
      _ref5$required = _ref5.required,
      required = _ref5$required === void 0 ? false : _ref5$required;
  var templateString = '';

  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'menu.subtitle');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'menu.subtitle');
  }

  return templateString;
};
var retrieveRuleMenuAction = function retrieveRuleMenuAction(_ref6) {
  var ruleTemplates = _ref6.ruleTemplates,
      _ref6$required = _ref6.required,
      required = _ref6$required === void 0 ? false : _ref6$required;
  var templateString = '';

  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'menu.button');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'menu.button');
  }

  return templateString;
};
var getHeaderDescription = function getHeaderDescription(loader) {
  switch (loader && loader.pricing && loader.pricing.monetization && loader.pricing.monetization.type && loader.pricing.monetization.type) {
    case 'pass':
      return 'Already a pass holder?';

    case 'donation':
      return 'Already a donor?';

    case 'subscription':
      if (loader && loader.pricing && loader.pricing.monetization && loader.pricing.monetization.is_pledge) {
        return 'Already a member?';
      }

      return 'Already a subscriber?';

    case 'group':
      return 'Already have an account?';

    default:
      return 'Already have an account?';
  }
};

var popups = function popups(duck) {
  return {
    popups: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(duck.selectors.topScopeLoader, function (_ref) {
        var _ref$popups = _ref.popups,
            popups = _ref$popups === void 0 ? [] : _ref$popups;
        return _toConsumableArray(popups).sort(function (_ref2, _ref3) {
          var a = _ref2.order;
          var b = _ref3.order;
          return a - b;
        });
      });
    }),
    scopedPopups: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(function (state) {
        var _state$duck$store, _state$duck$store$sco;

        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'guest';
        return state === null || state === void 0 ? void 0 : (_state$duck$store = state[duck.store]) === null || _state$duck$store === void 0 ? void 0 : (_state$duck$store$sco = _state$duck$store[scope]) === null || _state$duck$store$sco === void 0 ? void 0 : _state$duck$store$sco.popups;
      }, function () {
        var popups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return _toConsumableArray(popups).sort(function (_ref4, _ref5) {
          var a = _ref4.order;
          var b = _ref5.order;
          return a - b;
        });
      });
    }),
    // because of popup optimization, if we go from
    // guest -> authed and vice versa
    // the later store has the cached popups
    allPopups: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(function (state) {
        return duck.selectors.scopedPopups(state, 'user');
      }, function (state) {
        return duck.selectors.scopedPopups(state);
      }, duck.selectors.getDefaultPopup, function (userPopups, guestPopups, defaultPopup) {
        var allPopups = [];

        if (defaultPopup !== null && defaultPopup !== void 0 && defaultPopup.id) {
          allPopups = [].concat(_toConsumableArray(userPopups.filter(function (popup) {
            return defaultPopup.id !== (popup === null || popup === void 0 ? void 0 : popup.id);
          })), _toConsumableArray(guestPopups.filter(function (popup) {
            return defaultPopup.id !== (popup === null || popup === void 0 ? void 0 : popup.id);
          })), [defaultPopup]);
        } else {
          allPopups = [].concat(_toConsumableArray(userPopups), _toConsumableArray(guestPopups));
        }

        return allPopups.sort(function (_ref6, _ref7) {
          var a = _ref6.order;
          var b = _ref7.order;
          return a - b;
        });
      });
    }),
    customProperties: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(duck.selectors.topScopeLoader, function (_ref8) {
        var custom_properties = _ref8.custom_properties;
        return custom_properties;
      });
    }),
    popupNewsletters: function popupNewsletters(state, popupId) {
      var _popups$find;

      var popups = duck.selectors.allPopups(state);
      return ((_popups$find = popups.find(function (_ref9) {
        var id = _ref9.id;
        return popupId === id;
      })) === null || _popups$find === void 0 ? void 0 : _popups$find.newsletters) || [];
    },
    popupAuthenticationMethods: function popupAuthenticationMethods(state, popupId) {
      var _popups$find2;

      var popups = duck.selectors.allPopups(state);
      return ((_popups$find2 = popups.find(function (_ref10) {
        var id = _ref10.id;
        return popupId === id;
      })) === null || _popups$find2 === void 0 ? void 0 : _popups$find2.authentication_methods) || [];
    },
    popupPlanOptions: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(duck.selectors.popups, function (popups) {
        return popups.filter(function (_ref11) {
          var type = _ref11.type;
          return type === 'offer';
        }).reduce(function (options, popup) {
          var _popup$products;

          popup === null || popup === void 0 ? void 0 : (_popup$products = popup.products) === null || _popup$products === void 0 ? void 0 : _popup$products.forEach(function (product) {
            options = [].concat(_toConsumableArray(options), _toConsumableArray(product.options));
          });
          return options;
        }, []).map(function (_ref12) {
          var id = _ref12.id,
              rest = _objectWithoutProperties(_ref12, ["id"]);

          return Object.assign({
            plan_option_id: id,
            id: id
          }, rest);
        });
      });
    }),
    popupUserOffer: function popupUserOffer(state) {
      var currentProductOptionId = duck.selectors.currentProductOptionId(state);

      if (!currentProductOptionId) {
        return null;
      } // const currentProductOptionId = '5c00c747-4089-48af-a1d5-f04795f38100'


      var popups = duck.selectors.popups(state);
      var userOffer = popups.reduce(function (acc) {
        var _ref13 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            products = _ref13.products;

        var offer = products === null || products === void 0 ? void 0 : products.find(function (_ref14) {
          var id = _ref14.id;
          return id === currentProductOptionId;
        });

        if (offer) {
          return offer;
        }

        return acc;
      }, null);
      return userOffer;
    },
    popupGetProductByProductOptionId: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(duck.selectors.allPopups, function (_, productOptionId) {
        return productOptionId;
      }, function (allPopups, productOptionId) {
        var products = allPopups.reduce(function (acc) {
          var _ref15 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              products = _ref15.products;

          return [].concat(_toConsumableArray(acc), _toConsumableArray(products ? products : []));
        }, []);
        var product = products.find(function (_ref16) {
          var _ref16$options = _ref16.options,
              options = _ref16$options === void 0 ? [] : _ref16$options;
          return options.some(function (option) {
            return (option === null || option === void 0 ? void 0 : option.id) === productOptionId || (option === null || option === void 0 ? void 0 : option.short_code) === productOptionId;
          });
        });
        return product;
      });
    }),
    popupGetOptionById: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(function (state, optionId) {
        return duck.selectors.popupGetProductByProductOptionId(state, optionId);
      }, function (_, optionId) {
        return optionId;
      }, function (product, optionId) {
        var option = ((product === null || product === void 0 ? void 0 : product.options) || []).find(function (_ref17) {
          var id = _ref17.id,
              short_code = _ref17.short_code;
          return optionId === id || optionId === short_code;
        });
        return option;
      });
    }),
    popupGetPopupByProductId: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(duck.selectors.allPopups, function (_, productId) {
        return productId;
      }, function (allPopups, productId) {
        var popup = allPopups.find(function () {
          var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              products = _ref18.products;

          return products ? products.some(function (product) {
            return (product === null || product === void 0 ? void 0 : product.id) === productId;
          }) : false;
        });
        return popup || {};
      });
    }),
    popupGetPopupByProductOptionId: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(duck.selectors.allPopups, function (_, optionId) {
        return optionId;
      }, function (allPopups, optionId) {
        var popup = allPopups.find(function () {
          var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              products = _ref19.products;

          return products ? products.some(function (product) {
            return product === null || product === void 0 ? void 0 : product.options.find(function (option) {
              return (option === null || option === void 0 ? void 0 : option.id) === optionId || (option === null || option === void 0 ? void 0 : option.short_code) === optionId;
            });
          }) : false;
        });
        return popup || {};
      });
    }),
    popupGetPopupById: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(duck.selectors.allPopups, function (_, popupId) {
        return popupId;
      }, function (allPopups, popupId) {
        var popup = allPopups.find(function (popup) {
          return ((popup === null || popup === void 0 ? void 0 : popup.id) === popupId || (popup === null || popup === void 0 ? void 0 : popup.short_code) === popupId) && popup.fetched;
        }); // else it was never fetched

        if (!popup) {
          popup = allPopups.find(function (popup) {
            return (popup === null || popup === void 0 ? void 0 : popup.id) === popupId || (popup === null || popup === void 0 ? void 0 : popup.short_code) === popupId;
          });
        }

        return popup;
      });
    }),
    popupGetProductFields: function popupGetProductFields(state, productId) {
      var product = duck.selectors.popupGetProductById(state, productId);
      var customPropertyValues = duck.selectors.customProperties(state) || {};
      var fields = (product === null || product === void 0 ? void 0 : product.fields) || [];
      var typeMap = {
        // Custom property types
        dropdown: 'Dropdown',
        short_answer: 'Text',
        number: 'Number',
        // types needed:
        // radio
        // checkboxes
        // boolean
        // date
        // paragraph
        // url
        // Standard property types
        first_name: 'Text',
        last_name: 'Text',
        address: 'Address',
        phone_number: 'Text',
        gender: 'Text',
        birthday: 'Text',
        date: 'Date'
      };
      var mappedFields = fields.map(function (field) {
        var _field$connected_prop, _field$connected_prop2, _field$connected_prop3, _field$connected_prop4;

        var formattedFields = {
          id: field === null || field === void 0 ? void 0 : (_field$connected_prop = field.connected_property) === null || _field$connected_prop === void 0 ? void 0 : _field$connected_prop.id,
          title: field === null || field === void 0 ? void 0 : field.label,
          description: field === null || field === void 0 ? void 0 : field.description,
          type: typeMap === null || typeMap === void 0 ? void 0 : typeMap[field === null || field === void 0 ? void 0 : (_field$connected_prop2 = field.connected_property) === null || _field$connected_prop2 === void 0 ? void 0 : _field$connected_prop2.type],
          required: field === null || field === void 0 ? void 0 : field.is_required,
          order: field === null || field === void 0 ? void 0 : field.order,
          options: field === null || field === void 0 ? void 0 : (_field$connected_prop3 = field.connected_property) === null || _field$connected_prop3 === void 0 ? void 0 : _field$connected_prop3.options
        };

        if (customPropertyValues[field === null || field === void 0 ? void 0 : (_field$connected_prop4 = field.connected_property) === null || _field$connected_prop4 === void 0 ? void 0 : _field$connected_prop4.id]) {
          var _field$connected_prop5;

          formattedFields.defaultValue = customPropertyValues[field === null || field === void 0 ? void 0 : (_field$connected_prop5 = field.connected_property) === null || _field$connected_prop5 === void 0 ? void 0 : _field$connected_prop5.id];
        }

        return formattedFields;
      });
      return mappedFields;
    },
    popupGetFields: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(duck.selectors.popupGetPopupById, duck.selectors.customProperties, function (popup) {
        var customPropertyValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var fields = (popup === null || popup === void 0 ? void 0 : popup.fields) || [];
        var typeMap = {
          // Custom property types
          dropdown: 'Dropdown',
          short_answer: 'Text',
          number: 'Number',
          // types needed:
          // radio
          // checkboxes
          // boolean
          // date
          // paragraph
          // url
          // Standard property types
          first_name: 'Text',
          last_name: 'Text',
          address: 'Address',
          phone_number: 'Text',
          gender: 'Text',
          birthday: 'Text',
          date: 'Date'
        };
        var mappedFields = fields.map(function (field) {
          var _field$connected_prop6, _field$connected_prop7, _field$connected_prop8, _field$connected_prop9;

          var formattedFields = {
            id: field === null || field === void 0 ? void 0 : (_field$connected_prop6 = field.connected_property) === null || _field$connected_prop6 === void 0 ? void 0 : _field$connected_prop6.id,
            title: field === null || field === void 0 ? void 0 : field.label,
            description: field === null || field === void 0 ? void 0 : field.description,
            type: typeMap === null || typeMap === void 0 ? void 0 : typeMap[field === null || field === void 0 ? void 0 : (_field$connected_prop7 = field.connected_property) === null || _field$connected_prop7 === void 0 ? void 0 : _field$connected_prop7.type],
            required: field === null || field === void 0 ? void 0 : field.is_required,
            order: field === null || field === void 0 ? void 0 : field.order,
            options: field === null || field === void 0 ? void 0 : (_field$connected_prop8 = field.connected_property) === null || _field$connected_prop8 === void 0 ? void 0 : _field$connected_prop8.options
          };

          if (customPropertyValues[field === null || field === void 0 ? void 0 : (_field$connected_prop9 = field.connected_property) === null || _field$connected_prop9 === void 0 ? void 0 : _field$connected_prop9.id]) {
            var _field$connected_prop10;

            formattedFields.defaultValue = customPropertyValues[field === null || field === void 0 ? void 0 : (_field$connected_prop10 = field.connected_property) === null || _field$connected_prop10 === void 0 ? void 0 : _field$connected_prop10.id];
          }

          return formattedFields;
        });
        return mappedFields;
      });
    }),
    popupGetProductById: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(duck.selectors.allPopups, function (_, productId) {
        return productId;
      }, function (allPopups, productId) {
        var products = allPopups.reduce(function (acc) {
          var _ref20 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              products = _ref20.products;

          return [].concat(_toConsumableArray(acc), _toConsumableArray(products ? products : []));
        }, []);
        var product = products.find(function (_ref21) {
          var id = _ref21.id;
          return id === productId;
        });
        return product;
      });
    }),
    popupIsPledge: function popupIsPledge(state) {
      var _ref22 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          productId = _ref22.productId,
          optionId = _ref22.optionId;

      if (productId) {
        var product = duck.selectors.popupGetProductById(state, productId);
        return product === null || product === void 0 ? void 0 : product.pledge_mode;
      }

      if (optionId) {
        var _product = duck.selectors.popupGetProductByProductOptionId(state, optionId);

        return _product === null || _product === void 0 ? void 0 : _product.pledge_mode;
      }

      return null;
    },
    getFirstOptionTypeOfPopup: function getFirstOptionTypeOfPopup(popup) {
      var _popup$products2, _popup$products2$, _popup$products2$$opt, _popup$products2$$opt2;

      var type = popup === null || popup === void 0 ? void 0 : (_popup$products2 = popup.products) === null || _popup$products2 === void 0 ? void 0 : (_popup$products2$ = _popup$products2[0]) === null || _popup$products2$ === void 0 ? void 0 : (_popup$products2$$opt = _popup$products2$.options) === null || _popup$products2$$opt === void 0 ? void 0 : (_popup$products2$$opt2 = _popup$products2$$opt[0]) === null || _popup$products2$$opt2 === void 0 ? void 0 : _popup$products2$$opt2.type;

      if ((popup === null || popup === void 0 ? void 0 : popup.type) !== 'offer' || !type) {
        return null;
      }

      return type;
    },
    passNewRegular: function passNewRegular(popup) {
      var type = duck.selectors.getFirstOptionTypeOfPopup(popup);
      return type === 'pass';
    },
    subscriptionExistingSwitch: function subscriptionExistingSwitch(state, option) {
      // console.log('subscriptionExistingSwitch', state, option)
      return false;
    },
    subscriptionNewPledge: function subscriptionNewPledge(state, option) {
      // console.log('subscriptionNewPledge', state, option)
      return false;
    },
    subscriptionNewRegular: function subscriptionNewRegular(state, option) {
      // console.log('subscriptionNewRegular', state, option)
      return false;
    },
    getDefaultPopup: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(duck.selectors.topScopeLoader, function () {
        var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            default_popup = _ref23.default_popup;

        return default_popup;
      });
    }),
    getPaymentPopupCustomTextFileName: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(duck.selectors.getDefaultPopup, function () {
        var _custom_text$payment;

        var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            custom_text = _ref24.custom_text;

        return custom_text === null || custom_text === void 0 ? void 0 : (_custom_text$payment = custom_text.payment) === null || _custom_text$payment === void 0 ? void 0 : _custom_text$payment.file_name;
      });
    }),
    getPaymentPopupCustomTextFileNameById: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(duck.selectors.popupGetPopupById, function () {
        var _custom_text$payment2;

        var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            custom_text = _ref25.custom_text;

        return custom_text === null || custom_text === void 0 ? void 0 : (_custom_text$payment2 = custom_text.payment) === null || _custom_text$payment2 === void 0 ? void 0 : _custom_text$payment2.file_name;
      });
    }),
    getAckPopupCustomTextFileNameById: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(duck.selectors.popupGetPopupById, function () {
        var _custom_text$ack_defa;

        var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            custom_text = _ref26.custom_text;

        return custom_text === null || custom_text === void 0 ? void 0 : (_custom_text$ack_defa = custom_text.ack_default) === null || _custom_text$ack_defa === void 0 ? void 0 : _custom_text$ack_defa.file_name;
      });
    }),
    getSignupPopupCustomTextFileNameById: new Duck__default['default'].Selector(function () {
      return reselect.createSelector(duck.selectors.popupGetPopupById, function () {
        var _custom_text$signup;

        var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            custom_text = _ref27.custom_text;

        return custom_text === null || custom_text === void 0 ? void 0 : (_custom_text$signup = custom_text.signup) === null || _custom_text$signup === void 0 ? void 0 : _custom_text$signup.file_name;
      });
    })
  };
};

var getContrastColor = functions.colors.getContrastColor;

var sortByKey = function sortByKey(items, key) {
  return items.slice().sort(function (a, b) {
    return a[key] - b[key];
  });
};
var selectorsDefault = (function (duck) {
  var popupsSelectors = popups(duck);
  return Object.assign({}, popupsSelectors, {
    loader: function loader(state) {
      return state === null || state === void 0 ? void 0 : state.loader;
    },
    topScopeLoader: function topScopeLoader(state) {
      var _state$duck$store, _state$duck$store2;

      return (state === null || state === void 0 ? void 0 : (_state$duck$store = state[duck.store]) === null || _state$duck$store === void 0 ? void 0 : _state$duck$store.user) || (state === null || state === void 0 ? void 0 : (_state$duck$store2 = state[duck.store]) === null || _state$duck$store2 === void 0 ? void 0 : _state$duck$store2.guest) || {};
    },
    hasGuestLoader: function hasGuestLoader(state) {
      return !!state[duck.store].guest;
    },
    hasUserLoader: function hasUserLoader(state) {
      return !!state[duck.store].user;
    },
    memberType: function memberType(form) {
      var isPledge = duck.selectors.monetizationIsPledge(form);

      if (isPledge) {
        return 'member';
      }

      var isSubscription = duck.selectors.monetizationTypeIsSubscription(form);

      if (isSubscription) {
        return 'subscriber';
      }

      var isPass = duck.selectors.monetizationTypeIsPass(form);

      if (isPass) {
        return 'pass holder';
      }

      var isDonation = duck.selectors.monetizationTypeIsDonation(form);

      if (isDonation) {
        return 'donor';
      }

      return null;
    },
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    intervalAdverb: function intervalAdverb(interval) {
      switch (interval) {
        case 'Month':
          return 'Monthly';

        case 'Year':
          return 'Yearly';

        case 'month':
          return 'monthly';

        case 'year':
          return 'yearly';
      }

      return '';
    },
    orderSummary: function orderSummary(state, _ref) {
      var productId = _ref.productId,
          optionId = _ref.optionId,
          customPrice = _ref.customPrice;

      if (!productId || !optionId) {
        return null;
      }

      var product = duck.selectors.popupGetProductById(state, productId);
      var option = duck.selectors.popupGetOptionById(state, optionId); //const showCurrencyCode = option.currency !== 'USD'

      var showCurrencyCode = true;

      if (!option || !product) {
        return null;
      }

      var isPledge = duck.selectors.popupIsPledge(state, {
        productId: productId
      });
      var intervalAdverb = duck.selectors.capitalizeFirstLetter(duck.selectors.intervalAdverb(option.interval));
      var formattedOptionType = isPledge ? 'membership' : option.type;
      var productTitle = product.title || 'No Title';
      var optionTypeAndInterval = "".concat(intervalAdverb, " ").concat(duck.selectors.memberNounFromString(formattedOptionType));
      var renewalDate = moment__default['default']().add(option.interval_quantity, option.interval).format('LL');
      var optionPrice = currency__default['default'].format({
        currencyCode: option.currency,
        amount: option.price,
        symbol: !showCurrencyCode
      });
      var optionInterval = option.interval;
      var currentSubscriptionPrice = duck.selectors.currentSubscriptionPrice(state);
      var currentSubscriptionCurrency = duck.selectors.currentSubscriptionCurrency(state);
      var oldOptionPrice = currentSubscriptionPrice && currentSubscriptionCurrency ? currency__default['default'].format({
        currencyCode: currentSubscriptionCurrency,
        amount: currentSubscriptionPrice,
        symbol: !showCurrencyCode
      }) : null;
      var parsedCustomPrice = parseInt(customPrice);
      var optionCustomPrice = !Number.isNaN(parsedCustomPrice) && currency__default['default'].format({
        currencyCode: option.currency,
        amount: parsedCustomPrice,
        symbol: !showCurrencyCode
      });
      var passDuration = option.type === 'pass' && "".concat(option.interval_quantity, " ").concat(option.interval).concat(option.interval_quantity > 1 ? 's' : '');

      var priceText = function priceText(price, cur) {
        return "".concat(price, " ").concat(currency__default['default'].symbol(cur), " ").concat(cur) ;
      };

      return Object.assign({
        productTitle: productTitle,
        optionTypeAndInterval: optionTypeAndInterval,
        renewalDate: renewalDate,
        optionPrice: priceText(optionPrice, option.currency),
        optionInterval: optionInterval
      }, oldOptionPrice && {
        oldOptionPrice: priceText(oldOptionPrice, currentSubscriptionCurrency)
      }, optionCustomPrice && {
        optionCustomPrice: priceText(optionCustomPrice, option.currency)
      }, passDuration && {
        passDuration: passDuration
      });
    },
    userWindowObject: function userWindowObject(state) {
      var id = duck.selectors.userId(state);
      var email = duck.selectors.userEmail(state);
      var authenticated = duck.selectors.userAuth(state);
      var first_name = duck.selectors.userFirstName(state);
      var last_name = duck.selectors.userLastName(state);
      var membership_type = duck.selectors.currentSubscriptionType(state);
      var tier = duck.selectors.currentSubscriptionPlanTierTitle(state);
      var group_name = duck.selectors.groupName(state);
      var total_paid = duck.selectors.currentBillingIntervalTotalPaid(state);
      var recurring_payment = duck.selectors.currentSubscriptionPrice(state);
      var verified = duck.selectors.userVerified(state);
      return {
        id: id,
        authenticated: authenticated,
        email: email,
        verified: verified,
        first_name: first_name,
        last_name: last_name,
        membership_type: membership_type,
        tier: tier,
        group_name: group_name,
        total_paid: total_paid,
        recurring_payment: recurring_payment
      };
    },
    // -----
    // Used In
    // Account menu - Notification.KeepPlan.js (pass holder excluded)
    // -----
    memberNoun: function memberNoun(form) {
      var memberType = duck.selectors.memberType(form);

      switch (memberType) {
        case 'member':
          return 'membership';

        case 'subscriber':
          return 'subscription';

        case 'pass holder':
          return 'pass';

        case 'donor':
          return 'contribution';

      }

      return '';
    },
    memberNounFromString: function memberNounFromString(string) {
      var isPledge = string === 'membership';

      if (isPledge) {
        return 'membership';
      }

      var isSubscription = string === 'subscription';

      if (isSubscription) {
        return 'subscription';
      }

      var isPass = string === 'pass';

      if (isPass) {
        return 'pass';
      }

      var isDonation = string === 'recurring-donation' || string === 'single-donation';

      if (isDonation) {
        return 'contribution';
      }

      return null;
    },
    // -----
    // Used In
    // Account menu - ManagePlan.Subscription.StopSubscription (pass holder excluded)
    // -----
    memberVerbPresentParticiple: function memberVerbPresentParticiple(state) {
      var memberType = duck.selectors.memberType(state);

      switch (memberType) {
        case 'member':
          return 'your membership';

        case 'subscriber':
          return 'subscribing';

        case 'pass holder':
          return 'your pass';

        case 'donor':
          return 'contributing';

      }

      return '';
    },
    isFetching: function isFetching(state) {
      return state.loader.isFetching;
    },
    isNotFetching: function isNotFetching(state) {
      return !state.loader.isFetching;
    },
    publisherId: function publisherId(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader.publisher || !loader.publisher.id) {
        return null;
      }

      return loader.publisher.id;
    },
    publisherName: function publisherName(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader.publisher || !loader.publisher.name) {
        return null;
      }

      return loader.publisher.name;
    },
    publisherUsername: function publisherUsername(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader.publisher || !loader.publisher.username) {
        return null;
      }

      return loader.publisher.username;
    },
    publisherIcon: function publisherIcon(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader.publisher || !loader.publisher.icon) {
        return null;
      }

      return loader.publisher.icon;
    },
    publisherUrl: function publisherUrl(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader.publisher || !loader.publisher.url) {
        return null;
      }

      return loader.publisher.url;
    },
    supportEmail: function supportEmail(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader.publisher || !loader.publisher.support_email) {
        return null;
      }

      return loader.publisher.support_email;
    },
    userFullName: function userFullName(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      return state[duck.store].user.user.full_name;
    },
    userFirstName: function userFirstName(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      return state[duck.store].user.user.first_name;
    },
    userLastName: function userLastName(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      return state[duck.store].user.user.last_name;
    },
    userEmail: function userEmail(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      return state[duck.store].user.user.email;
    },
    userAuth: function userAuth(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return false;
      }

      return state[duck.store].user.user.auth;
    },
    userId: function userId(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      return state[duck.store].user.user.id;
    },
    userHasPassword: function userHasPassword(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      return state[duck.store].user.user.has_password;
    },
    userAvatarUrl: function userAvatarUrl(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      return state[duck.store].user.user.avatar_url;
    },
    userInitials: function userInitials(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      var user = state[duck.store].user.user;
      return isEmpty__default['default'](user.initials) ? user.email[0] : user.initials;
    },
    userStatus: function userStatus(state) {
      var has_purchase = duck.selectors.userHasCurrentPurchases(state);
      var registered = duck.selectors.userId(state);
      var is_group_member = duck.selectors.isGroupMember(state);

      if (has_purchase || is_group_member) {
        return 'paying';
      } else if (registered) {
        return 'registered';
      }

      return 'anonymous';
    },
    userVerified: function userVerified(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return false;
      }

      return state[duck.store].user.user.verified;
    },
    userSyncNewsletters: function userSyncNewsletters(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return false;
      }

      return state[duck.store].user.user.sync;
    },
    currentSubscriptionPrice: function currentSubscriptionPrice(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_price) {
        return null;
      }

      return state[duck.store].user.purchases.current.subscription_price;
    },
    currentSubscriptionCurrency: function currentSubscriptionCurrency(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_currency) {
        return null;
      }

      return state[duck.store].user.purchases.current.subscription_currency;
    },
    currentSubscriptionType: function currentSubscriptionType(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_type) {
        return null;
      }

      return state[duck.store].user.purchases.current.subscription_type;
    },
    currentSubscriptionTypeIsPass: function currentSubscriptionTypeIsPass(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_type) {
        return false;
      }

      return state[duck.store].user.purchases.current.subscription_type === 'pass';
    },
    currentSubscriptionTypeIsRecurringDonation: function currentSubscriptionTypeIsRecurringDonation(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_type) {
        return false;
      }

      return state[duck.store].user.purchases.current.subscription_type === 'recurring-donation';
    },
    currentSubscriptionTypeIsSubscription: function currentSubscriptionTypeIsSubscription(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_type) {
        return false;
      }

      return state[duck.store].user.purchases.current.subscription_type === 'subscription';
    },
    currentSubscriptionIsTrial: function currentSubscriptionIsTrial(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current) {
        return false;
      }

      return state[duck.store].user.purchases.current.subscription_trial_end !== null;
    },
    currentSubscriptionStart: function currentSubscriptionStart(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_start) {
        return null;
      }

      return state[duck.store].user.purchases.current.subscription_start;
    },
    currentProductTitle: function currentProductTitle(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.product_title) {
        return null;
      }

      return state[duck.store].user.purchases.current.product_title;
    },
    currentProductId: function currentProductId(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.product_id) {
        return null;
      }

      return state[duck.store].user.purchases.current.product_id;
    },
    currentProductOptionId: function currentProductOptionId(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.product_option_id) {
        return null;
      }

      return state[duck.store].user.purchases.current.product_option_id;
    },
    currentProductOptionCurrency: function currentProductOptionCurrency(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.product_option_currency) {
        return null;
      }

      return state[duck.store].user.purchases.current.product_option_currency;
    },
    currentSubscriptionId: function currentSubscriptionId(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_id) {
        return null;
      }

      return state[duck.store].user.purchases.current.subscription_id;
    },
    currentSubscriptionIdIsGift: function currentSubscriptionIdIsGift(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_id) {
        return false;
      }

      return state[duck.store].user.purchases.current.subscription_id === 'GIFT';
    },
    currentSubscriptionEnd: function currentSubscriptionEnd(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_end) {
        return null;
      }

      return state[duck.store].user.purchases.current.subscription_end;
    },
    currentSubscriptionPlanTierTitle: function currentSubscriptionPlanTierTitle(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.product_title) {
        return null;
      }

      return state[duck.store].user.purchases.current.product_title;
    },
    currentPurchaseCanceled: function currentPurchaseCanceled(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.status) {
        return null;
      }

      return state[duck.store].user.purchases.current.status === 'CANCELED';
    },
    currentPurchaseActive: function currentPurchaseActive(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.status) {
        return null;
      }

      return state[duck.store].user.purchases.current.status === 'ACTIVE';
    },
    currentPurchaseFailed: function currentPurchaseFailed(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.status) {
        return null;
      }

      return state[duck.store].user.purchases.current.status === 'FAILED';
    },
    updatePaymentMethodText: function updatePaymentMethodText(state) {
      var memberType = duck.selectors.memberType(state);

      switch (memberType) {
        case 'member':
        case 'subscriber':
          return 'Please update your payment method to restore subscription benefits.';

        case 'donor':
          return 'Please update your payment method to restore your donation.';

      }

      return '';
    },
    badgePaymentMethod: function badgePaymentMethod(state) {
      var _state$duck$store3, _state$duck$store3$us, _state$duck$store3$us2;

      var firstPaymentMethod = state === null || state === void 0 ? void 0 : (_state$duck$store3 = state[duck.store]) === null || _state$duck$store3 === void 0 ? void 0 : (_state$duck$store3$us = _state$duck$store3.user) === null || _state$duck$store3$us === void 0 ? void 0 : (_state$duck$store3$us2 = _state$duck$store3$us.paymentMethods) === null || _state$duck$store3$us2 === void 0 ? void 0 : _state$duck$store3$us2[0];

      if (!firstPaymentMethod || !(firstPaymentMethod !== null && firstPaymentMethod !== void 0 && firstPaymentMethod.cardType) || !(firstPaymentMethod !== null && firstPaymentMethod !== void 0 && firstPaymentMethod.last4)) {
        return null;
      }

      return {
        cardType: firstPaymentMethod.cardType,
        last4: firstPaymentMethod.last4
      };
    },
    nextSubscriptionStart: function nextSubscriptionStart(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.next || !state[duck.store].user.purchases.history.next.subscription_start) {
        return null;
      }

      return state[duck.store].user.purchases.history.next.subscription_start;
    },
    nextSubscriptionEnd: function nextSubscriptionEnd(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.next || !state[duck.store].user.purchases.history.next.subscription_end) {
        return null;
      }

      return state[duck.store].user.purchases.history.next.subscription_end;
    },
    nextStatusNext: function nextStatusNext(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.next || !state[duck.store].user.purchases.history.next.status) {
        return false;
      }

      return state[duck.store].user.purchases.history.next.status === 'NEXT';
    },
    nextProductOptionPrice: function nextProductOptionPrice(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.next || !state[duck.store].user.purchases.history.next.product_option_price) {
        return null;
      }

      return state[duck.store].user.purchases.history.next.product_option_price;
    },
    nextProductOptionInterval: function nextProductOptionInterval(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.next || !state[duck.store].user.purchases.history.next.product_option_interval) {
        return null;
      }

      return state[duck.store].user.purchases.history.next.product_option_interval;
    },
    allNewsletters: function allNewsletters(state) {
      var _state$duck$store4, _state$duck$store4$us, _state$duck$store5, _state$duck$store5$gu;

      return ((_state$duck$store4 = state[duck.store]) === null || _state$duck$store4 === void 0 ? void 0 : (_state$duck$store4$us = _state$duck$store4.user) === null || _state$duck$store4$us === void 0 ? void 0 : _state$duck$store4$us.newsletters) || ((_state$duck$store5 = state[duck.store]) === null || _state$duck$store5 === void 0 ? void 0 : (_state$duck$store5$gu = _state$duck$store5.guest) === null || _state$duck$store5$gu === void 0 ? void 0 : _state$duck$store5$gu.newsletters) || [];
    },
    subscribedNewsletters: function subscribedNewsletters(state) {
      var newsletters = duck.selectors.allNewsletters(state);
      return newsletters.filter(function (_ref2) {
        var subscribed = _ref2.subscribed;
        return subscribed;
      });
    },
    firstDonation: function firstDonation(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.first_donation) {
        return null;
      }

      return state[duck.store].user.purchases.history.first_donation;
    },
    currentBillingIntervalTotalPaid: function currentBillingIntervalTotalPaid(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.current_billing_interval_total_paid) {
        return null;
      }

      return state[duck.store].user.purchases.history.current_billing_interval_total_paid;
    },
    originalEnrollmentDate: function originalEnrollmentDate(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.originalEnrollmentDate) {
        return null;
      }

      return state[duck.store].user.purchases.history.originalEnrollmentDate;
    },
    next: function next(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.next || Object.keys(state[duck.store].user.purchases.history.next).length === 0) {
        return null;
      }

      return state[duck.store].user.purchases.history.next;
    },
    monetizationBillingStatus: function monetizationBillingStatus(state) {
      var _loader$purchases, _loader$purchases$his;

      var loader = duck.selectors.topScopeLoader(state);
      return loader !== null && loader !== void 0 && (_loader$purchases = loader.purchases) !== null && _loader$purchases !== void 0 && (_loader$purchases$his = _loader$purchases.history) !== null && _loader$purchases$his !== void 0 && _loader$purchases$his.has_purchased ? 'PAID' : null;
    },
    pricingHasMonetization: function pricingHasMonetization(form) {
      return ((form === null || form === void 0 ? void 0 : form.products) || []).some(function (product) {
        var _product$options;

        return !!(product !== null && product !== void 0 && (_product$options = product.options) !== null && _product$options !== void 0 && _product$options.length);
      });
    },
    userHasCurrentPurchases: function userHasCurrentPurchases(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current) {
        return false;
      }

      return Object.keys(state[duck.store].user.purchases.current).length > 0;
    },
    monetizationIsPledge: function monetizationIsPledge(form) {
      var _form$products;

      var orderType = duck.selectors.getOrderType((form === null || form === void 0 ? void 0 : (_form$products = form.products) === null || _form$products === void 0 ? void 0 : _form$products.length) && form.products[0]) || '';
      return orderType.includes('pledge');
    },
    monetizationTypeIsSubscription: function monetizationTypeIsSubscription(form) {
      var _form$products2;

      var orderType = duck.selectors.getOrderType((form === null || form === void 0 ? void 0 : (_form$products2 = form.products) === null || _form$products2 === void 0 ? void 0 : _form$products2.length) && form.products[0]) || '';
      return orderType.includes('subscription');
    },
    monetizationTypeIsDonation: function monetizationTypeIsDonation(form) {
      var _form$products3;

      var orderType = duck.selectors.getOrderType((form === null || form === void 0 ? void 0 : (_form$products3 = form.products) === null || _form$products3 === void 0 ? void 0 : _form$products3.length) && form.products[0]) || '';
      return orderType.includes('donation');
    },
    monetizationTypeIsGroup: function monetizationTypeIsGroup(form) {
      var _form$products4;

      var orderType = duck.selectors.getOrderType((form === null || form === void 0 ? void 0 : (_form$products4 = form.products) === null || _form$products4 === void 0 ? void 0 : _form$products4.length) && form.products[0]) || '';
      return orderType.includes('group');
    },
    monetizationTypeIsPass: function monetizationTypeIsPass(form) {
      var _form$products5;

      var orderType = duck.selectors.getOrderType((form === null || form === void 0 ? void 0 : (_form$products5 = form.products) === null || _form$products5 === void 0 ? void 0 : _form$products5.length) && form.products[0]) || '';
      return orderType.includes('pass');
    },
    isGroupAdmin: function isGroupAdmin(state) {
      if (!state[duck.store].user || !state[duck.store].user.group || !state[duck.store].user.group.admin) {
        return false;
      }

      return state[duck.store].user.group.admin;
    },
    isGroupMember: function isGroupMember(state) {
      if (!state[duck.store].user || !state[duck.store].user.group || !state[duck.store].user.group.member) {
        return false;
      }

      return state[duck.store].user.group.member;
    },
    groupName: function groupName(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader || !loader.group || !loader.group.name) {
        return null;
      }

      return loader.group.name;
    },
    groupSize: function groupSize(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader || !loader.group || !loader.group.size) {
        return null;
      }

      return loader.group.size;
    },
    userHasGroupData: function userHasGroupData(state) {
      if (!state[duck.store].user || !state[duck.store].user.group) {
        return false;
      }

      return Object.keys(state[duck.store].user.group).length > 1;
    },
    linkColor: function linkColor(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader.publisher || !loader.publisher.styling || !loader.publisher.styling.linkColor) {
        return '';
      }

      return loader.publisher.styling.linkColor;
    },
    contrastColor: function contrastColor(state) {
      var linkColor = duck.selectors.linkColor(state);
      var contrastColor = getContrastColor(linkColor);
      return contrastColor;
    },
    scopedLoader: function scopedLoader(state, scope) {
      return state.loader[scope];
    },
    tiers: new Duck__default['default'].Selector(function (selectors) {
      return function (state) {
        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'guest';
        return get__default['default'](selectors.scopedLoader(state, scope), 'pricing.monetization.tiers', []);
      };
    }),
    tiersSorted: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.tiers, function (items) {
        return sortByKey(items, 'tierOrder');
      });
    }),
    planTexts: new Duck__default['default'].Selector(function (selectors) {
      return function (state) {
        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'guest';
        var form = arguments.length > 2 ? arguments[2] : undefined;
        var loader = selectors.scopedLoader(state, scope);

        if (loader) {
          var _form$products6, _form$products$;

          var monetizationType = (form === null || form === void 0 ? void 0 : (_form$products6 = form.products) === null || _form$products6 === void 0 ? void 0 : _form$products6.length) && ((_form$products$ = form.products[0]) === null || _form$products$ === void 0 ? void 0 : _form$products$.type);
          var hasPurchased = loader.purchases && loader.purchases.history && loader.purchases.history.has_purchased;
          var planTemplates = loader.lang.plan;
          var userFirstName = loader.user.first_name;
          var texts = retrievePlanPrompt({
            planTemplates: planTemplates,
            userFirstName: userFirstName,
            monetizationType: monetizationType,
            hasPurchased: hasPurchased
          });
          return texts;
        }

        return null;
      };
    }),
    ruleTexts: new Duck__default['default'].Selector(function (selectors) {
      return function (state) {
        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'guest';
        var loader = selectors.scopedLoader(state, scope);

        if (loader) {
          var values = Object.assign({
            prompt: {
              title: '',
              subTitle: '',
              description: ''
            },
            menu: {
              title: '',
              subTitle: '',
              button: ''
            }
          }, scope === 'guest' && {
            headerDescription: getHeaderDescription(loader)
          });
          var ruleTemplates = loader.lang.rule;
          var publicationName = loader.publisher.name;
          values.prompt.title = compile(retrieveRulePromptTitle({
            ruleTemplates: ruleTemplates
          }), {
            publication_name: publicationName
          });
          values.prompt.subTitle = retrieveRulePromptSubtitle({
            ruleTemplates: ruleTemplates
          });
          values.prompt.description = retrieveRulePromptDescription({
            ruleTemplates: ruleTemplates
          });
          values.menu.title = compile(retrieveRuleMenuTitle({
            ruleTemplates: ruleTemplates
          }), {
            publication_name: publicationName
          });
          values.menu.subTitle = retrieveRuleMenuSubtitle({
            ruleTemplates: ruleTemplates
          });
          values.menu.button = retrieveRuleMenuAction({
            ruleTemplates: ruleTemplates
          });
          return values;
        }

        return null;
      };
    }),
    featureList: new Duck__default['default'].Selector(function (selectors) {
      return function (state) {
        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'guest';
        return get__default['default'](selectors.scopedLoader(state, scope), 'lang.plan.tiers', []);
      };
    }),
    pubPriceChangeDate: function pubPriceChangeDate(state) {
      var _loader$purchases2, _loader$purchases2$hi;

      var loader = duck.selectors.topScopeLoader(state);
      var changes = loader === null || loader === void 0 ? void 0 : (_loader$purchases2 = loader.purchases) === null || _loader$purchases2 === void 0 ? void 0 : (_loader$purchases2$hi = _loader$purchases2.history) === null || _loader$purchases2$hi === void 0 ? void 0 : _loader$purchases2$hi.changes;

      if (!changes) {
        return null;
      }

      var changeDate = changes.reduce(function (acc) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            logType = _ref3.logType,
            loggedAt = _ref3.loggedAt;

        if (acc) {
          return acc;
        }

        if (logType === 'PUB_PRICE_CHANGE') {
          return loggedAt;
        }

        return acc;
      }, null);
      return changeDate;
    },
    articleId: function articleId(state) {
      var _loader$article;

      var loader = duck.selectors.topScopeLoader(state);
      var articleId = loader === null || loader === void 0 ? void 0 : (_loader$article = loader.article) === null || _loader$article === void 0 ? void 0 : _loader$article.id;
      return articleId ? articleId : null;
    },
    promptTriggerRuleId: function promptTriggerRuleId(state) {
      var _loader$pricing, _loader$pricing$ident;

      var loader = duck.selectors.topScopeLoader(state);
      var ruleId = loader === null || loader === void 0 ? void 0 : (_loader$pricing = loader.pricing) === null || _loader$pricing === void 0 ? void 0 : (_loader$pricing$ident = _loader$pricing.identification) === null || _loader$pricing$ident === void 0 ? void 0 : _loader$pricing$ident.identification_rule_id;
      return ruleId ? ruleId : null;
    },
    promptTriggerPlanId: function promptTriggerPlanId(state) {
      var _loader$pricing2, _loader$pricing2$mone;

      var loader = duck.selectors.topScopeLoader(state);
      var planId = loader === null || loader === void 0 ? void 0 : (_loader$pricing2 = loader.pricing) === null || _loader$pricing2 === void 0 ? void 0 : (_loader$pricing2$mone = _loader$pricing2.monetization) === null || _loader$pricing2$mone === void 0 ? void 0 : _loader$pricing2$mone.plan_id;
      return planId ? planId : null;
    },
    getOrderType: function getOrderType(product, _option) {
      var _product$options2;

      var productType = null;
      var option = _option || (product !== null && product !== void 0 && (_product$options2 = product.options) !== null && _product$options2 !== void 0 && _product$options2.length ? product.options[0] : {});
      var type = option.type;

      if (type === 'subscription') {
        var isPledgeMode = product.pledge_mode;
        var isTrial = (!!option.trial_price || option.trial_price === null) && !!option.trial_interval && !!option.trial_quantity;

        if (isPledgeMode) {
          productType = 'pledge';
        } else if (isTrial) {
          productType = 'trial';
        } else {
          productType = type;
        }
      } else {
        productType = type;
      }

      return productType;
    }
  });
});

var storeDefault = 'loader';
var index = (function (_ref) {
  var _ref$store = _ref.store,
      store = _ref$store === void 0 ? storeDefault : _ref$store,
      createDuck = _ref.createDuck,
      _ref$initialState = _ref.initialState,
      initialState$1 = _ref$initialState === void 0 ? initialState : _ref$initialState,
      _ref$creators = _ref.creators,
      creators$1 = _ref$creators === void 0 ? creators : _ref$creators,
      _ref$types = _ref.types,
      types$1 = _ref$types === void 0 ? types : _ref$types,
      _ref$reducer = _ref.reducer,
      reducer$1 = _ref$reducer === void 0 ? reducer : _ref$reducer,
      _ref$sagas = _ref.sagas,
      sagas$1 = _ref$sagas === void 0 ? sagas : _ref$sagas,
      _ref$takes = _ref.takes,
      takes$1 = _ref$takes === void 0 ? takes : _ref$takes,
      _ref$selectors = _ref.selectors,
      selectors = _ref$selectors === void 0 ? selectorsDefault : _ref$selectors;
  return createDuck({
    store: store,
    initialState: initialState$1
  }).extend({
    creators: creators$1,
    types: types$1,
    reducer: reducer$1,
    sagas: sagas$1,
    takes: takes$1,
    selectors: selectors
  });
});

exports.creators = creators;
exports.default = index;
exports.initialState = initialState;
exports.reducer = reducer;
exports.sagas = sagas;
exports.selectors = selectorsDefault;
exports.store = storeDefault;
exports.takes = takes;
exports.types = types;
